export const personalInfo = {
  name: "Prasanna Dangol",
  role: "FULL STACK DEVELOPER",
  subRole: "Full Stack • IT Systems • DevOps",
  location: "Nepal",
  relocation: "Open to Work",
  email: "dangolprasanna2001@gmail.com",
  phone: "+977-9840807275",
  linkedin: "https://linkedin.com/in/dangolprasanna",
  github: "https://github.com/dangolprasanna",
  resume: "/PD_resume25.pdf",
  birthDate: "2001-09-22T00:00:00",
  city: "Kathmandu, NP",
  heroLine:
    "Software Developer at Sustainable Eco Engineering (CBFEWS Project, UNDP) with 3+ years across Information Systems, web & mobile apps, and IT support. I build real-time flood early warning platforms (React/Django), reporting dashboards for program monitoring, and offline-first systems for field teams — covering user support, access controls, backups, and system reliability.",
  stats: [
    { label: "YEARS_EXP", value: "3+" },
    { label: "APP_DOWNLOADS", value: "40K+" },
    { label: "ORGANIC_VIEWS", value: "2M+" },
    { label: "OPEN_TO_WORK", value: "YES" },
  ],
};